// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `motes-login-overlay {
  pointer-events: none;
}

#login-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  transition: 2s;
  pointer-events: initial;
  z-index: 9;
}

#login-overlay.hide-login-overlay {
  pointer-events: none;
  background: transparent;
  opacity: 0 !important;
  transition: 0.5s;
}

#login-overlay-container {
  backface-visibility: hidden;
  transform: translateZ(1);
  position: relative;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 4px;
  overflow-y: auto;
  margin: auto;
  opacity: 1;
  transition: 0.4;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: 1s;
  z-index: 10;
  pointer-events: initial;
  overflow: hidden;
}

#login-overlay-container.hide-container {
  transform: translate(-50%, -150%);
  transition: 1s;
  opacity: 0;
  pointer-events: none;
}

motes-login .motes-input {
  padding: 10px;
}
motes-login #login-container.motes-card {
  transition: 0.2s;
  padding: 5%;
}
motes-login #login-container.motes-card.transparent-bg {
  background-color: transparent;
  color: var(--motes-white);
  border: none;
  box-shadow: none;
  margin: 0;
  padding: 3%;
  padding-top: 0;
}
motes-login #login-container.motes-card.transparent-bg .loading-dots .lds-ellipsis > * {
  background: var(--motes-white);
}
motes-login #login-container.motes-card h3 {
  margin-top: 0;
}
motes-login #login-container.motes-card .small-body {
  margin: 0;
}
motes-login .info-text {
  min-height: 3em;
  opacity: 0;
  transition: 0.2s opacity;
}
motes-login .info-text.show {
  opacity: 1;
}
motes-login .loading-dots {
  margin-top: var(--large-spacing);
  text-align: center;
  height: 20px;
}
motes-login .toggleMode div {
  display: inline-block;
  border-bottom: 5px solid transparent;
  padding-right: 10px;
  margin: 0;
}
motes-login .toggleMode div.activeMode {
  border-bottom: 5px solid blue;
}
motes-login #close-login {
  position: absolute;
  top: 5px;
  right: 15px;
  font-size: 30px;
}
motes-login button.motes-button:disabled {
  opacity: 0.7;
}
motes-login button.google {
  background: #dd4b39;
  border: #dd4b39;
  color: var(--motes-white);
  text-transform: none;
}
motes-login button.google:hover, motes-login button.google:active {
  background: #ff7c6c;
  border: #ff7c6c;
}
motes-login button.apple {
  background: black;
  border: black;
  color: var(--motes-white);
  text-transform: none;
}
motes-login button.apple:hover, motes-login button.apple:active {
  background: #545454;
  border: #545454;
}
motes-login button.facebook {
  background: #3b5998;
  border: #3b5998;
  color: var(--motes-white);
  text-transform: none;
}
motes-login button.facebook:hover, motes-login button.facebook:active {
  background: #4f70b6;
  border: #4f70b6;
}
motes-login button.email {
  text-transform: none;
}
motes-login hr {
  background: #666;
  height: 1px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
  margin: 15px 0;
  opacity: 0.3;
  border: none;
}
motes-login .back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--mini-spacing);
  margin-top: var(--large-spacing);
  height: 20px;
  cursor: pointer;
}
motes-login .back-button:hover {
  color: var(--primary-color);
}
motes-login .tiny-button {
  cursor: pointer;
  color: var(--motes-gray);
  text-align: center;
  margin: var(--large-spacing) 0;
}
motes-login .tiny-button.hover {
  text-decoration: underline;
}
motes-login .reqTime {
  cursor: pointer;
}
motes-login svg-icon[name=back] {
  position: relative;
  top: 2px;
}
motes-login .lds-ellipsis {
  position: relative;
  display: inline-block;
  height: 20px;
  width: 80px;
}
motes-login .lds-ellipsis div {
  position: absolute;
  top: 0;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #333;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
motes-login .lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
motes-login .lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
motes-login .lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
motes-login .lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/motes-login/motes-login.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ;;AAEA;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,8BAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;AACJ;;AAEA;EACI,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AACJ;;AAEA;EAEI,2BAAA;EACA,wBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,iCAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;AAAJ;;AAKI;EACI,aAAA;AAFR;AAKI;EACI,gBAAA;EACA,WAAA;AAHR;AAKQ;EACI,6BAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;AAHZ;AAKY;EACI,8BAAA;AAHhB;AAOQ;EACI,aAAA;AALZ;AAQQ;EACI,SAAA;AANZ;AAUI;EACI,eAAA;EACA,UAAA;EACA,wBAAA;AARR;AAUQ;EACI,UAAA;AARZ;AAYI;EACI,gCAAA;EACA,kBAAA;EACA,YAAA;AAVR;AAaI;EACI,qBAAA;EACA,oCAAA;EACA,mBAAA;EACA,SAAA;AAXR;AAcI;EACI,6BAAA;AAZR;AAeI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;AAbR;AAgBI;EACI,YAAA;AAdR;AAiBI;EACI,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;AAfR;AAiBQ;EACI,mBAAA;EACA,eAAA;AAfZ;AAmBI;EACI,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;AAjBR;AAmBQ;EACI,mBAAA;EACA,eAAA;AAjBZ;AAqBI;EACI,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;AAnBR;AAqBQ;EACI,mBAAA;EACA,eAAA;AAnBZ;AAuBI;EACI,oBAAA;AArBR;AAwBI;EACI,gBAAA;EACA,WAAA;EACA,uCAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AAtBR;AAyBI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gCAAA;EACA,YAAA;EACA,eAAA;AAvBR;AAyBQ;EACI,2BAAA;AAvBZ;AA2BI;EACI,eAAA;EACA,wBAAA;EACA,kBAAA;EACA,8BAAA;AAzBR;AA2BQ;EACI,0BAAA;AAzBZ;AA6BI;EACI,eAAA;AA3BR;AA8BI;EACI,kBAAA;EACA,QAAA;AA5BR;AA+BI;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AA7BR;AA+BI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AA7BR;AA+BI;EACI,SAAA;EACA,sCAAA;AA7BR;AA+BI;EACI,SAAA;EACA,sCAAA;AA7BR;AA+BI;EACI,UAAA;EACA,sCAAA;AA7BR;AA+BI;EACI,UAAA;EACA,sCAAA;AA7BR;AA+BI;EACI;IACI,mBAAA;EA7BV;EA+BM;IACI,mBAAA;EA7BV;AACF;AA+BI;EACI;IACI,mBAAA;EA7BV;EA+BM;IACI,mBAAA;EA7BV;AACF;AA+BI;EACI;IACI,0BAAA;EA7BV;EA+BM;IACI,6BAAA;EA7BV;AACF","sourcesContent":["motes-login-overlay {\n    pointer-events: none;\n}\n\n#login-overlay {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    width: 100%;\n    background: rgba(0,0,0,.4);\n    transition: 2s;\n    pointer-events: initial;\n    z-index: 9;\n}\n\n#login-overlay.hide-login-overlay {\n    pointer-events: none;\n    background: transparent;\n    opacity: 0 !important;\n    transition: .5s;\n}\n\n#login-overlay-container {\n    // Fix blury issue with translating overlay with % in chrome\n    backface-visibility: hidden;\n    transform: translateZ(1);\n    position: relative;\n    width: 90%;\n    max-width: 400px;\n    max-height: 90vh;\n    overflow-y: auto;\n    border-radius: 4px;\n    overflow-y: auto;\n    margin: auto;\n    opacity: 1;\n    transition: .4;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    transition: 1s;\n    z-index: 10;\n    pointer-events: initial;\n    overflow: hidden;\n}\n\n#login-overlay-container.hide-container {\n    transform: translate(-50%, -150%);\n    transition: 1s;\n    opacity: 0;\n    pointer-events: none;\n}\n\nmotes-login {\n\n    .motes-input {\n        padding: 10px;\n    }\n\n    #login-container.motes-card {\n        transition: .2s;\n        padding: 5%;\n\n        &.transparent-bg {\n            background-color: transparent;\n            color: var(--motes-white);\n            border: none;\n            box-shadow: none;\n            margin: 0;\n            padding: 3%;\n            padding-top: 0;\n\n            .loading-dots .lds-ellipsis > * {\n                background: var(--motes-white);\n            }\n        }\n\n        h3 {\n            margin-top: 0;\n        }\n\n        .small-body {\n            margin: 0;\n        }\n    }\n\n    .info-text {\n        min-height: 3em;\n        opacity: 0;\n        transition: 0.2s opacity;\n\n        &.show {\n            opacity: 1;\n        }\n    }\n\n    .loading-dots {\n        margin-top: var(--large-spacing);\n        text-align: center;\n        height: 20px;\n    }\n\n    .toggleMode div {\n        display: inline-block;\n        border-bottom: 5px solid transparent;\n        padding-right: 10px;\n        margin: 0;\n    }\n\n    .toggleMode div.activeMode {\n        border-bottom: 5px solid blue;\n    }\n\n    #close-login {\n        position: absolute;\n        top: 5px;\n        right: 15px;\n        font-size: 30px;\n    }\n\n    button.motes-button:disabled {\n        opacity: .7;\n    }\n\n    button.google {\n        background: #dd4b39;\n        border: #dd4b39;\n        color: var(--motes-white);\n        text-transform: none;\n\n        &:hover, &:active {\n            background: #ff7c6c;\n            border: #ff7c6c;\n        }\n    }\n\n    button.apple {\n        background: black;\n        border: black;;\n        color: var(--motes-white);\n        text-transform: none;\n\n        &:hover, &:active {\n            background: #545454;\n            border: #545454;\n        }\n    }\n\n    button.facebook {\n        background: #3b5998;\n        border: #3b5998;\n        color: var(--motes-white);\n        text-transform: none;\n\n        &:hover, &:active {\n            background: #4f70b6;\n            border: #4f70b6;\n        }\n    }\n\n    button.email {\n        text-transform: none;\n    }\n\n    hr {\n        background: #666;\n        height: 1px;\n        box-shadow: 0 0 10px rgba(0,0,0,.8);\n        margin: 15px 0;\n        opacity: .3;\n        border: none;\n    }\n\n    .back-button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: var(--mini-spacing);\n        margin-top: var(--large-spacing);\n        height: 20px;\n        cursor: pointer;\n        \n        &:hover {\n            color: var(--primary-color);\n        }\n    }\n\n    .tiny-button {\n        cursor: pointer;\n        color: var(--motes-gray);\n        text-align: center;\n        margin: var(--large-spacing) 0;\n\n        &.hover {\n            text-decoration: underline;\n        }\n    }\n\n    .reqTime {\n        cursor: pointer;\n    }\n\n    svg-icon[name=\"back\"] {\n        position: relative;\n        top: 2px;\n    }\n\n    .lds-ellipsis {\n        position: relative;\n        display: inline-block;\n        height: 20px;\n        width: 80px;\n    }\n    .lds-ellipsis div {\n        position: absolute;\n        top: 0;\n        width: 13px;\n        height: 13px;\n        border-radius: 50%;\n        background: #333;\n        animation-timing-function: cubic-bezier(0, 1, 1, 0);\n    }\n    .lds-ellipsis div:nth-child(1) {\n        left: 8px;\n        animation: lds-ellipsis1 0.6s infinite;\n    }\n    .lds-ellipsis div:nth-child(2) {\n        left: 8px;\n        animation: lds-ellipsis2 0.6s infinite;\n    }\n    .lds-ellipsis div:nth-child(3) {\n        left: 32px;\n        animation: lds-ellipsis2 0.6s infinite;\n    }\n    .lds-ellipsis div:nth-child(4) {\n        left: 56px;\n        animation: lds-ellipsis3 0.6s infinite;\n    }\n    @keyframes lds-ellipsis1 {\n        0% {\n            transform: scale(0);\n        }\n        100% {\n            transform: scale(1);\n        }\n    }\n    @keyframes lds-ellipsis3 {\n        0% {\n            transform: scale(1);\n        }\n        100% {\n            transform: scale(0);\n        }\n    }\n    @keyframes lds-ellipsis2 {\n        0% {\n            transform: translate(0, 0);\n        }\n        100% {\n            transform: translate(24px, 0);\n        }\n    }      \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
